module.exports = __webpack_public_path__ + "media/images/static/our_work/02_lifestyle-17f6428e850ec184930a21b3cad093fa.png";